import {
  GET_HUBSPOT_DEALS,
  GET_HUBSPOT_DEALS_SUCCESS,
  GET_HUBSPOT_DEALS_FAILURE,
} from './constants';

const initialState = {
  dealsSummary: { data: [], loading: false, loaded: false, error: null },
};

const hubspotAPI = (state = initialState, action) => {
  switch (action.type) {
    case GET_HUBSPOT_DEALS:
      return {
        ...state,
        dealsSummary: { ...state.dealsSummary, loading: true, loaded: false, error: null },
      };
    case GET_HUBSPOT_DEALS_SUCCESS:
      return {
        ...state,
        dealsSummary: { data: action.payload, loading: false, loaded: true, error: null },
      };
    case GET_HUBSPOT_DEALS_FAILURE:
      return {
        ...state,
        dealsSummary: { ...state.dealsSummary, loading: false, loaded: false, error: action.payload },
      };
    default:
      return state;
  }
};

export default hubspotAPI;
